export const ACTION_RESET = 'FETCH_STORY_RESET';
export const ACTION_REQUEST = 'FETCH_STORY_REQUEST';
export const ACTION_SUCCESS = 'FETCH_STORY_SUCCESS';
export const ACTION_ERROR = 'FETCH_STORY_ERROR';
